export const PARAM_KEYS = ["fn", "ln", "email", "phone", "state", "zip"];

const SESSION_KEY = "tfh_session";
const PARAMS_KEY = "tfh_params";

export const getSession = () => {
  let s = sessionStorage.getItem(SESSION_KEY);
  if (!s) {
    s = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
    sessionStorage.setItem(SESSION_KEY, s);
  }
  return s;
};

export const getParams = () => sessionStorage.getItem(PARAMS_KEY) || "";

export const setParams = (qs) => sessionStorage.setItem(PARAMS_KEY, qs);

export const buildParams = (obj) => {
  const sp = new URLSearchParams();
  PARAM_KEYS.forEach((k) => {
    if (obj[k]) sp.set(k, obj[k]);
  });
  return sp.toString();
};

export const withParams = (url) => {
  const qs = getParams();
  if (!qs) return url;
  return url + (url.includes("?") ? "&" : "?") + qs;
};

export const getCustomer = () => {
  const sp = new URLSearchParams(getParams());
  const name = [sp.get("fn"), sp.get("ln")].filter(Boolean).join(" ");
  const email = sp.get("email");
  if (!name && !email) return "";
  return email ? `${name ? name + " · " : ""}${email}` : name;
};
